// @flow

import css from '@styles/productDetail';

export default function BackToSearchButton({ url }: { url: string }) {
  return (
    <a href={url} className={css.backToSearch}>
      &lt; Back To Search Results
    </a>
  );
}
